// The bag's customer strip under the name: last visit, a birthday this week,
// their sizes per category, open wishes and the next follow-up. The client
// book is read once per customer while online; offline the strip shows what
// the customer record and their loaded bills already say.
import React, { useEffect, useState } from "react";
import { fashionPosService } from "../../../../services";
import { buildClientBookQuery, readClientItems } from "../../../../utils/fashion/clientBook";
import { buildAlterationsQuery, readAlterations, searchTerm } from "../../../../utils/fashion/alterations";
import { bagClientFacts } from "../../../../utils/fashion/bagClient";
import { usualSizeLine } from "../../../../utils/fashion/sizeSheet";

export default function BagClientStrip({ customer, bunitId, isOnline, bagProductIds = [] }) {
  const customerId = customer?.cwrCustomerId;
  const mobileNo = customer?.mobileNo || "";
  const [rows, setRows] = useState(null);
  const [alterations, setAlterations] = useState(null);
  useEffect(() => {
    setRows(null);
    if (!customerId || isOnline === false) return undefined;
    let live = true;
    (async () => {
      try {
        const read = readClientItems(await fashionPosService(buildClientBookQuery(customerId)), "getFashionClientBook");
        if (live) setRows(read);
      } catch {
        // The strip still shows the customer record's facts.
      }
    })();
    return () => {
      live = false;
    };
  }, [customerId, isOnline]);

  // Their ready alterations at this store, found by mobile number.
  useEffect(() => {
    setAlterations(null);
    if (!customerId || !bunitId || !mobileNo || isOnline === false) return undefined;
    let live = true;
    (async () => {
      try {
        const read = readAlterations(await fashionPosService(buildAlterationsQuery(bunitId, "RDY", searchTerm(mobileNo), 20)));
        if (live) setAlterations(read);
      } catch {
        // No alteration fact; the rest of the strip still shows.
      }
    })();
    return () => {
      live = false;
    };
  }, [customerId, bunitId, mobileNo, isOnline]);

  const facts = bagClientFacts(customer, bunitId, { sizes: usualSizeLine(customer), rows, bagProductIds, alterations });
  if (facts.length === 0) return null;
  return (
    <ul className="fp-bc-facts" aria-label="About this customer">
      {facts.map((f) => (
        <li key={f.key} className={`fp-bc-fact is-${f.tone}`}>
          {f.label}
        </li>
      ))}
    </ul>
  );
}
